/**
 * Convert an ISO 3166-1 alpha-2 country code to a Twemoji CDN SVG URL.
 *
 * Regional indicator symbols: each ASCII letter maps to U+1F1E6..U+1F1FF.
 * Special case: XR (Tibet) → mountain emoji 🏔️ (U+1F3D4).
 */

export const TWEMOJI_BASE =
  'https://cdn.jsdelivr.net/gh/twitter/twemoji@14.0.2/assets/svg';

export function countryCodeToFlagUrl(code: string): string {
  if (!code || code.length !== 2) return '';

  const upper = code.toUpperCase();

  // Tibet uses mountain emoji
  if (upper === 'XR') {
    return `${TWEMOJI_BASE}/1f3d4.svg`;
  }

  const codepoints = [...upper].map((ch) =>
    (ch.charCodeAt(0) - 65 + 0x1f1e6).toString(16)
  );

  return `${TWEMOJI_BASE}/${codepoints.join('-')}.svg`;
}
